export default "__VITE_ASSET__qm6qC_u$__"